import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Message, SpinnerService } from 'shared-components';
import { AdminService } from "../../../services/admin.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Subject } from "rxjs";

@Component({
    selector: 'app-versiones-etiquetado-new-edit',
    templateUrl: './new-edit.component.html'
})
export class VersionesEtiquetadoNewEditComponent implements OnInit {

    private _versionSw;
    public denominaciones;
    public lsActualizacionAutomatica;

    public newEditForm: UntypedFormGroup;

    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();

    @Input() versionSwId;
    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _adminService: AdminService
    ) {}
    
    ngOnInit() {
        this.newEditForm = this._fb.group({
            version: ['', [Validators.required, Validators.pattern('^[0-9]+[.][0-9]+[.][0-9]+[.][0-9]+$')]],
            observaciones: [''],
            actualizacionAutomaticaTodasLicencias: [false]
        });


        if (this.versionSwId) {
            this.getVersionSw();
        }
    }

    public getVersionSw() {
        this._spinnerService.showSpinner();
        this._adminService.getVersionEtiquetado(this.versionSwId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this._versionSw = resp;
            this.newEditForm.patchValue({
                version: resp.des,
                observaciones: resp.observaciones
            });
        }, (error) => {
            this.showApiError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.versionSwId) {
            this._versionSw = {
                des: this.newEditForm.get('version').value,
                observaciones: this.newEditForm.get('observaciones').value ? this.newEditForm.get('observaciones').value : '',
                actualizacionAutomaticaTodasLicencias: this.newEditForm.get('actualizacionAutomaticaTodasLicencias').value,
                lsActualizacionAutomaticaPD: this.lsActualizacionAutomatica,
                tipoSwId: 1
            };
            this._spinnerService.showSpinner();
            this._adminService.createVersionEtiquetado(this._versionSw).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemCreated');
                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        } else if (this.newEditForm.valid && this.versionSwId) {
            this._versionSw = {
                id: this.versionSwId,
                des: this.newEditForm.get('version').value,
                observaciones: this.newEditForm.get('observaciones').value ? this.newEditForm.get('observaciones').value : '',
                actualizacionAutomaticaTodasLicencias: this.newEditForm.get('actualizacionAutomaticaTodasLicencias').value,
                lsActualizacionAutomaticaPD: this.lsActualizacionAutomatica,
                tipoSwId: 1
            }
            this._spinnerService.showSpinner();
            this._adminService.updateVersionEtiquetado(this._versionSw).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        }
    }

    public close() {
        this.refresh.emit(false);
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            if (this.newEditForm.get('version').hasError('required')) {
                this.mensajes.push({ class: 'error', message: 'global.error.required' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.formatoVersion'})
            }
        }
    }
}